export const
	FUNCTION_CONSTRUCTOR_OFFSET_SCRIPT = "LoremIpsum",
	MAX_LOCK_PENDING = Infinity,
	SAVE_SETTINGS_WAIT = 2

export namespace InternalDOMClasses {
	const NAMESPACE = "obsidian-plugin-library"
	export const
		AWAIT_CSS = `${NAMESPACE}:await-css`,
		HIDE_STATUS_BAR = `${NAMESPACE}:hide-status-bar`,
		ICON = `${NAMESPACE}:icon`
}
